/* eslint-disable no-unused-vars */
export enum TableDataCons {
    GETWORKGROUPCLASS = 'getWorkGroupClass',
    SETWORKGROUPCLASS = 'setWorkGroupClass',
    ADDWORKGROUPCLASS = 'addWorkGroupClass',
    EDITWORKGROUPCLASS = 'editWorkGroupClass',
    DELWORKGROUPCLASS = 'delWorkGroupClass',
    SETKEYROADMAPPAGINATION = 'setKeyRoadMapPagination',
    SETCLASSIFICATIONPAGINATION = 'setClassificationPagination',
    SETPROJECTINFOPAGINATION = 'setProjectInfoPagination',
    GETKEYROADMAP = 'getKeyRoadMap',
    SETKEYROADMAP = 'setKeyRoadMap',
    SETEDITDATA = 'setEditData',
    SETEDITDATA2 = 'setEditData2',
    CLEAREDITDATA2 = 'clearEditData2',
    GETTECHCLASSIFICATION = 'getTechClassification',
    SETTECHCLASSIFICATION = 'setTechClassification',
    GETPROJECTINFO = 'getProjectInfo',
    GETPROJECTINFOBYID = 'getProjectInfoById',
    SETPROJECTINFO = 'setProjectInfo',
    SETDICCLASSLIST = 'setDicClassList',
    CLEARSTORE = 'clearStore'
}
export enum ValidateStatus {
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    VALIDATING = 'validating'
}
export enum IReviewType {
    PLAN = 1,
    DEFINE = 2,
    RESULT = 3
}
